/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForVulnerability extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForVulnerability.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForVulnerability>): ProgressDetailsForVulnerability {
        let obj = Object.assign(new ProgressDetailsForVulnerability(), model);
        ProgressDetailsForVulnerability.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForVulnerability>): ProgressDetailsForVulnerability {
        if (!model) return null;
        return ProgressDetailsForVulnerability.newInstance(<ProgressDetailsForVulnerability> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForVulnerability) {
        if (!obj) return;

        models.ProgressDetailsForVulnerability.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForVulnerability): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForVulnerability.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.by_location) {
            for (let val of this.by_location) {
                models.ProgressDetailsMessagePerLocation.fixupPrototype(val);
            }
        }
    }

    by_location: Array<models.ProgressDetailsMessagePerLocation>;

}
